import { apiClient } from '../../../../../services/apiClient'
import type {
  Building,
  // BuildingSearchFilters,
  BuildingSearchRequest,
  BuildingSearchResponse,
} from '@popety-io/types'

export const buildingService = {
  search: async (
    request: BuildingSearchRequest
  ): Promise<BuildingSearchResponse> => {
    try {
      const response = await apiClient.post('/buildings/search', request)
      return response.data
    } catch (error) {
      console.error('Building search error:', error)
      throw error
    }
  },

  getById: async (id: string, fields?: string[]): Promise<Building> => {
    try {
      const query = fields
        ? `?fields=${encodeURIComponent(fields.join(','))}`
        : ''
      const response = await apiClient.get(`/buildings/${id}${query}`)
      return response.data
    } catch (error) {
      console.error('Building fetch error:', error)
      throw error
    }
  },

  /**
   * Get building data for Building Analysis page
   * Includes all fields necessary for comprehensive analysis
   */
  getBuildingForAnalysis: async (id: string): Promise<Building> => {
    const fields = [
      // Basic identification
      'id',
      'building_id',
      'egid',
      'geo_portal_link',

      // Location
      'city_name',
      'municipality_name',
      'district_name',
      'region_name',
      'address_full',
      'address_number',
      'geo_center',
      'geo_polygon',
      'address_postal_code_name',

      // Building properties
      'area',
      'building_year',
      'building_period',
      'renovation_year',
      'renovation_period',
      'floor_nb',
      'unit_nb',
      'height',
      'height_estimate',
      'building_volume',
      'gross_floor_area',

      // Categories and classification
      'category',
      'type',
      'status',
      'classification',
      'popety_classification',
      'principal_type',

      // Energy and environmental
      'heater_generator',
      'heater_water_generator',
      'additional_heater_generator',
      'additional_heater_water_generator',
      'power_source_heater',
      'power_source_water_heater',
      'energy_reference_area',
      'minergie',
      'solar_area',
      'solar_area_best',
      'solar_installed_power',
      'solar_installed_first_date',
      'solar_installed_date',
      'photovoltaic_history',
      'solar_electrical_efficiency',
      'solar_electrical_efficiency_best',
      'solar_global_exposure',
      'solar_global_exposure_best',

      // Geographic and environmental factors
      'altitude',
      'exposure',
      'slope',
      'lake_view',
      'mountain_view',
      'noise_exposure',
      'public_transport_quality',
      'tax_burden',
      'heat_consumption_index',

      // Dwelling information
      'unit_nb',
      'dwellings_nb',
      'dwelling_median_area',
      'dwelling_median_room_nb',
      'dwelling_min_area',
      'dwelling_max_area',

      // Administrative buildings
      'buildings_administrative',

      // Land information
      'lands',
      'lands_owners',
      'lands_owner_nb',
      'lands_private_owner_nb',
      'lands_public_owner_nb',
      'lands_institutional_owner_nb',

      // Market data
      'lands_transactions',
      'lands_building_permits',
      'listings',
      'listing_sale_number',
      'listing_sale_last_year',
      'listing_rent_number',
      'listing_rent_last_year',

      // Scores (if available)
      'building_elevation',

      // Protection
      'has_civil_protection_shelter',
      'protected_rank',
    ]

    return buildingService.getById(id, fields)
  },
}
